import AdvanceHistory from 'features/advance/screens/manageAdvanceAccount/AdvanceHistory/AdvanceHistory';
import React from 'react';

export default function AdvanceHistoryPage() {
  return <AdvanceHistory />;
}
